import { type TerritoryCode } from '../types/territory';
import { CountryCodes } from './currency';

export const getLocaleFromIsoCode = (isoCode: TerritoryCode | undefined): CountryCodes => {
  if (!isoCode) {
    return CountryCodes.SPAIN;
  }

  switch (isoCode) {
    case 'ES':
      return CountryCodes.SPAIN;
    case 'PT':
      return CountryCodes.PORTUGAL;
    case 'IT':
      return CountryCodes.ITALY;
    case 'CO':
      return CountryCodes.COLOMBIA;
    case 'PE':
      return CountryCodes.PERU;
    case 'FR':
      return CountryCodes.FRANCE;
    default:
      return CountryCodes.SPAIN;
  }
};
